import { render, staticRenderFns } from "./channel.history.vue?vue&type=template&id=2525da1e&"
import script from "./channel.history.vue?vue&type=script&lang=js&"
export * from "./channel.history.vue?vue&type=script&lang=js&"
import style0 from "./channel.history.vue?vue&type=style&index=0&id=2525da1e&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports